import { render, staticRenderFns } from "./AssetPreview.vue?vue&type=template&id=158fc0ec&scoped=true&"
import script from "./AssetPreview.vue?vue&type=script&lang=js&"
export * from "./AssetPreview.vue?vue&type=script&lang=js&"
import style0 from "./AssetPreview.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AssetPreview.vue?vue&type=style&index=1&id=158fc0ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "158fc0ec",
  null
  
)

export default component.exports